import { CalendarLinksBlockLayout as MobileLayout } from './CalendarLinksBlockLayout.mobile';
import { CalendarLinksBlockLayout as WebLayout } from './CalendarLinksBlockLayout.web';
import { isReactNative } from 'ui-builder';

export const CalendarLinksBlockLayout = isReactNative() ? MobileLayout : WebLayout;
